(() => {
  const TARGET_SELECTOR = [
    '.section--loot-product-apps',
    '.loot-product-apps-fullwidth',
    '#judgeme_product_reviews',
    '.jdgm-review-widget',
    '[data-judge-me-reviews]'
  ].join(',');

  function getTarget() {
    return document.querySelector(TARGET_SELECTOR);
  }

  function scrollToReviews(trigger) {
    const target = getTarget();
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => {
      const focusTarget = target.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 650);

    trigger?.blur?.();
  }

  function normalizeSummary(summary) {
    const badge = summary.querySelector('.jdgm-prev-badge');
    const text = (badge?.textContent || summary.textContent || '').trim().toLocaleLowerCase('tr-TR');
    const attrCount = Number.parseInt(summary.dataset.reviewCount || '0', 10);
    const badgeCount = Number.parseInt(badge?.dataset.numberOfReviews || badge?.getAttribute('data-number-of-reviews') || '', 10);
    const hasPositiveCount = (Number.isFinite(attrCount) && attrCount > 0) || (Number.isFinite(badgeCount) && badgeCount > 0);
    const looksEmpty = /0\s*(yorum|değerlendirme|review)|henüz.*(yorum|değerlendirme)|no reviews/.test(text);

    if (!hasPositiveCount && looksEmpty) summary.hidden = true;
  }

  function init(root = document) {
    root.querySelectorAll('[data-loot-review-scroll]').forEach((summary) => {
      if (summary.dataset.lootRatingReady === 'true') return;
      summary.dataset.lootRatingReady = 'true';

      summary.addEventListener('click', () => scrollToReviews(summary));
      summary.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          scrollToReviews(summary);
        }
      });

      normalizeSummary(summary);
      window.setTimeout(() => normalizeSummary(summary), 700);
      window.setTimeout(() => normalizeSummary(summary), 1800);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
